import { Fragment } from "react";
import {
  Box,
  Paper,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  CircularProgress,
  Fade
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import { useAgentChat } from "./AgentChatProvider";
import useStyles from "./styles";

export default function SessionSidebar() {
  const classes = useStyles();
  const {
    sessionList,
    activeSessionId,
    selectSession,
    isLoadingList,
    isCreating,
    token,
    createSession,
    deleteSession
  } = useAgentChat();

  const renderSessionList = () => {
    if (sessionList.length === 0) {
      return (
        <Box p={2} textAlign="center">
          <Typography variant="body2" color="textSecondary">
            No sessions yet
          </Typography>
        </Box>
      );
    }

    return sessionList.map((session) => (
      <Fragment key={session.id}>
        <ListItem
          className={`${classes.sessionItem} ${
            session.id === activeSessionId ? classes.sessionItemActive : ""
          }`}
          onClick={() => selectSession(session.id)}
        >
          <ListItemText
            primary={session.title || "New conversation"}
            primaryTypographyProps={{
              noWrap: true,
              style: { fontSize: 14 }
            }}
            secondary={new Date(session.created_at).toLocaleDateString()}
            secondaryTypographyProps={{
              style: { fontSize: 11 }
            }}
          />
          <ListItemSecondaryAction>
            <IconButton
              edge="end"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                deleteSession(session.id);
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
        <Divider />
      </Fragment>
    ));
  };

  return (
    <Paper className={classes.sidebar}>
      <Box className={classes.sidebarHeader}>
        <Typography variant="subtitle1">Sessions</Typography>
        <IconButton
          size="small"
          onClick={createSession}
          disabled={isCreating || !token}
        >
          {isCreating ? <CircularProgress size={20} /> : <AddIcon />}
        </IconButton>
      </Box>
      <List className={classes.sessionList}>
        {isLoadingList ? (
          <Fade in={isLoadingList}>
            <Box display="flex" justifyContent="center" p={2}>
              <CircularProgress size={24} />
            </Box>
          </Fade>
        ) : (
          renderSessionList()
        )}
      </List>
    </Paper>
  );
}
